import PropTypes from 'prop-types'
import { Icon } from '@leroy-merlin-br/backyard-react-ui'

import LeftIcon from '../LeftIcon'
import RightIcon from '../RightIcon'
import * as S from './styled'

const Navigation = ({ hasOffset, prevProps, nextProps }) => (
  <S.Navigation hasOffset={hasOffset}>
    <S.Box {...prevProps} side="left">
      <Icon as={LeftIcon} size="giga" />
    </S.Box>
    <S.Box {...nextProps} side="right">
      <Icon as={RightIcon} size="giga" />
    </S.Box>
  </S.Navigation>
)

Navigation.propTypes = {
  hasOffset: PropTypes.bool,
  prevProps: PropTypes.object.isRequired,
  nextProps: PropTypes.object.isRequired
}

export default Navigation
